import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'gsp-toast-banner',
  templateUrl: './toast-banner.component.html',
  styleUrls: ['./toast-banner.component.scss']
})
export class ToastBannerComponent implements OnInit {
  @Input() valueToDisplay: string;
  ngOnInit() { }
}